import { useTimeout } from '@fuse/hooks';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import usePageTitle from 'app/hooks/usePageTitle';
import { useTranslation } from 'react-i18next';

function FuseLoading(props) {
	const { t, ready } = useTranslation(undefined, { useSuspense: false });
	usePageTitle('Loading...');

	const [showLoading, setShowLoading] = useState(!props.delay);

	useTimeout(() => {
		setShowLoading(true);
	}, props.delay);

	if (!showLoading) {
		return null;
	}

	return (
		<div className="flex flex-1 flex-col items-center justify-center">
			<Typography className="text-20 mb-16" color="textSecondary">
				{ready ? t('Loading...') : '\u00A0'}
			</Typography>
			<LinearProgress className="w-xs" color="secondary" />
		</div>
	);
}

FuseLoading.propTypes = {
	delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

FuseLoading.defaultProps = {
	delay: false
};

export default FuseLoading;
